/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

$(document).ready(function () {   
  $('.featured-collection .product-list').each(function() {
    var featuredCollectionProductsPerRow = +$(this).attr('data-products-per-row');
    var featuredCollectionProductsPerRowTablet = 2;
    if (featuredCollectionProductsPerRow < 2) {
      featuredCollectionProductsPerRowTablet = featuredCollectionProductsPerRow;
    }

    $(this).slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 2,
      dots: true,                                                             
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none"><path d="M2.84495 19.5116L12.3566 9.99995L2.84495 0.488281L0.488281 2.84495L7.64328 9.99995L0.488281 17.1549L2.84495 19.5116Z" fill="#333333"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none"><path d="M2.84495 19.5116L12.3566 9.99995L2.84495 0.488281L0.488281 2.84495L7.64328 9.99995L0.488281 17.1549L2.84495 19.5116Z" fill="#333333"/></svg></button>',
      responsive: [
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 719,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
// .on('setPosition', function (event, slick) {
//     slick.$slides.css('height', slick.$slideTrack.height() + 'px');
// });
 

    //     var featuredCollectionImageHeight = $(this).find('.product-card-figure').outerHeight();
    //     var featuredCollectionArrowHeight = $(this).find('.slick-next').outerHeight();
    //     var self = this;
    //     $(this).find('.slick-next, .slick-prev').css('top', featuredCollectionImageHeight / 2 - featuredCollectionArrowHeight / 2 + 'px');

    //     $(window).resize(function() {
    //       featuredCollectionImageHeight = $(self).find('.product-card-figure').outerHeight();
    //       featuredCollectionArrowHeight = $(self).find('.slick-next').outerHeight();
    //       $(self).find('.slick-next, .slick-prev').css('top', featuredCollectionImageHeight / 2 - featuredCollectionArrowHeight / 2 + 'px');
    //     });
  });

  var gallery_viewport = $('[data-product-gallery-viewport]');
  var galliery_navigation = $('[data-product-gallery-navigation]');
  
  var sectionId = $('.page-body-content [data-section-data]').attr('data-section-id'); 
	var all_images_container = $('.Product__Slideshow_all_images_container');

  if(gallery_viewport.length && galliery_navigation.length && all_images_container.length == 0) {
    gallery_viewport.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll:1,
      asNavFor: '.product-gallery--navigation',
      prevArrow: '.gallery_prev-'+sectionId,
      nextArrow: '.gallery_next-'+sectionId
    });
    galliery_navigation.slick({
      arrows: false,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll:1,
      focusOnSelect: true,
      asNavFor: '.product-gallery--viewport',
      vertical: true,
      responsive: [
        {
          breakpoint: 719,
          settings: {
            vertical: false
          }
        }
      ]
    });
    
    galliery_navigation.on('afterChange', function(event, slick, currentSlide, nextSlide){
      if (currentSlide > 8) {
        $('.product-gallery--navigation-count .current').text(currentSlide + 1);
      } else {
        $('.product-gallery--navigation-count .current').text('0' + (currentSlide + 1));
      }
    });
  } 

  var headerHeight = $('.main-header-wrap').outerHeight();
  $('.ingredients-tables__back-to-top, .alphabet-link').on('click', function() {
  	$('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - headerHeight - 20
    }, 500);
  })
  
  $('.shop_the_look_metafields_slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll:1,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none"><path d="M2.84495 19.5116L12.3566 9.99995L2.84495 0.488281L0.488281 2.84495L7.64328 9.99995L0.488281 17.1549L2.84495 19.5116Z" fill="#333333"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none"><path d="M2.84495 19.5116L12.3566 9.99995L2.84495 0.488281L0.488281 2.84495L7.64328 9.99995L0.488281 17.1549L2.84495 19.5116Z" fill="#333333"/></svg></button>',
    responsive: [
      {
        breakpoint: 719,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.footer-linklist-title').on('click', function() {
    if ($(window).width() < 720) {
      $(this).next().slideToggle();
    }
  });
  
  $('.bundles-hero-panels-section .item').on('click', function() {
    if ($(window).width() < 720) {
      $(this).find('.products-panel').slideToggle();
    }
  });
});

document.addEventListener('click', function(e) {
  var el = e.target;
  if(el.closest('.custom-dropdown-wrapper')) {

    if(!el.classList.contains('main-field')) {
      el = el.closest('.main-field');
    }

    var customDropdownWrapper = el;

    if(customDropdownWrapper) {
      if(!customDropdownWrapper.classList.contains('custom-dropdown')) {
        customDropdownWrapper = customDropdownWrapper.closest('.custom-dropdown');
      }

      var customDropdown = customDropdownWrapper.querySelector('.main-field');





      var customDropdownList = el.nextElementSibling;      
      var bounding = customDropdown.getBoundingClientRect();
      var dropdownFromTop = bounding.top;

      if (customDropdownList != null) {
        if (customDropdownList.classList.contains('open')) {
          customDropdownList.classList.remove("open");
          customDropdown.classList.remove("top-list");
          customDropdown.classList.remove("bottom-list");
        } else {
          customDropdownList.classList.add("open");
          customDropdown.classList.add("bottom-list");
        }
      }
    }
  } else {
    if (document.querySelector('.custom-dropdown-list') != null && document.querySelector('.main-field') != null) {
      document.querySelector('.custom-dropdown-list').classList.remove("open");
      document.querySelector('.main-field').classList.remove("top-list");
      document.querySelector('.main-field').classList.remove("bottom-list");
    }
  }

});

document.addEventListener('click', function(e) {

  var el = e.target;
  if(el.classList.contains('custom-dropdown-list-item') || el.closest('.custom-dropdown-list-item')) {
    if(!el.classList.contains('custom-dropdown-list-item')) {
      el = el.closest('.custom-dropdown-list-item');
    }

    var elementParent = el.parentElement;
    var dropdownWrapper = elementParent.previousElementSibling;
    var elementContent = el.innerHTML;


    //var optionsSelect = document.querySelector('.single-option-selector');

    var optionValue = el.querySelector("span").innerHTML;
    if(elementParent.querySelector('.custom-dropdown-list-item.selected')) {
      elementParent.querySelector('.custom-dropdown-list-item.selected').classList.remove("selected");
    }
    el.classList.add("selected");
    dropdownWrapper.classList.remove("top-list");
    dropdownWrapper.classList.remove("bottom-list");
    elementParent.classList.remove("open");
    dropdownWrapper.innerHTML = elementContent;


    var color_value = el.getAttribute('data-color-value');
    console.log(el);
    console.log(1);
    var ColorSwatch__Radio_arr = el.closest('.options ').querySelectorAll('.option-value-input');
    for(var i=0;i < ColorSwatch__Radio_arr.length;i++) {
      var ColorSwatch__Radio = ColorSwatch__Radio_arr[i];
      var val = ColorSwatch__Radio.getAttribute('data-value');
      if(val == color_value) {
        ColorSwatch__Radio.click();
        break;
      }
    }
  }

});

$('.product-card-footer').matchHeight();

$(document).ready(function () {
  var topPromoSection = $('.top-promo-section');
  var mainHeader = $('#shopify-section-static-header');
  var topPromoSectionDelay = topPromoSection.attr('data-delay') * 1000;
  var topPromoSectionHeight;

  if (topPromoSectionDelay == 0) {
    topPromoSectionDelay = 500;
  }
 
  if (localStorage.getItem("hiddenTopPromoSection") != 'true') {
    setTimeout(function () {
      var copied_elem = topPromoSection.clone().css({visibility:"hidden", display:"block", position:"absolute"});
      $("body").append(copied_elem);
      topPromoSectionHeight = copied_elem.outerHeight();
      copied_elem.remove();
      console.log(topPromoSectionHeight)
      
      mainHeader.css('top', topPromoSectionHeight + 'px');
      topPromoSection.slideDown(300);
      topPromoSection.addClass('is-open');
    }, topPromoSectionDelay);
  }

  $(window).resize(function() {
    if (topPromoSection.hasClass('is-open')) {
      mainHeader.css('top', topPromoSection.outerHeight() + 'px');
    }
  });

  $('.top-promo-section .top-promo-section-close').on('click', function() {
    $('.top-promo-section').slideUp(300);
    mainHeader.css('top', '0');
    localStorage.setItem("hiddenTopPromoSection", "true");
  });
});























